module.exports = __webpack_public_path__ + "img/1 (5).8bd3f9fb.jpg";